import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { homeRouteI18n } from '../i18n/home-route-i18n';
import { langRouteI18n } from '../i18n/lang-route-i18n';

export function homeRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${homeRouteI18n()}`;
}
